function updateTimers() {

    let timers = document.querySelectorAll('.timer-block')

    timers.forEach(timer => {

        let endTime = new Date(timer.getAttribute('data-end-date')).getTime()
        let now = new Date().getTime()
        let timeToExpire = endTime - now

        if (timeToExpire <= 1100) {
            let autoUpdate = timer.getAttribute('data-auto-reload')

            if (autoUpdate) {
                let reloadDate = timer.getAttribute('data-reload-date')
                timer.setAttribute('data-end-date', reloadDate)

            } else {
                timeToExpire = 0
            }

        }

        let timeData = {
            d: String(Math.floor(timeToExpire / (1000 * 60 * 60 * 24))).padStart(2, '0'),
            h: String(Math.floor((timeToExpire % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
            i: String(Math.floor((timeToExpire % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
            s: String(Math.floor((timeToExpire % (1000 * 60)) / 1000)).padStart(2, '0'),
        }

        timer.querySelector(`span[data-event-timer-name="d"]`).innerText = timeData.d
        timer.querySelector(`span[data-event-timer-name="h"]`).innerText = timeData.h
        timer.querySelector(`span[data-event-timer-name="i"]`).innerText = timeData.i
        timer.querySelector(`span[data-event-timer-name="s"]`).innerText = timeData.s

    });
}

function startTimers() {
    setInterval(updateTimers, 1000);
    updateTimers();
}

module.exports = startTimers;
